<template>
	<FormItem :wrapper-col="wrapperCol">
		<HorizontalLayout>
			<slot></slot>
		</HorizontalLayout>
	</FormItem>
</template>

<script>
import { toRef, computed } from 'vue';
import { FormItem } from 'ant-design-vue';

import HorizontalLayout from '@/components/common/HorizontalLayout.vue';

export default {
	components: {
		FormItem, HorizontalLayout,
	},
	props: {
		span: {
			type: Number,
			default: 12,
		},
	},
	setup(props) {
		const spanRef = toRef(props, 'span');
		const wrapperCol = computed(() => ({
			offset: 0,
			span: 24,
			sm: { offset: 24 - spanRef.value, span: spanRef.value },
		}));
		return {
			wrapperCol,
		};
	},
};
</script>

<style scoped>
.allow-wrap {
	flex-wrap: wrap;
}
</style>
